export enum Experiment {
  AfterschoolQuiz5163 = 'after-school-quiz-BPD-5163',
  AfterschoolQuiz5610 = 'after-school-quiz-BPD-5610',
  AfterschoolQuiz5703 = 'after-school-quiz-BPD-5703',
}
